import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;

  padding: 20px;
  border-radius: ${radius.md};

  background: ${colors.surfaceContainerLow};
  border: 1px solid ${colors.outlineVariant}33;

  transition: border-color 0.2s;

  &:hover {
    border-color: ${colors.primary};
  }
`;

export const IconBox = styled.div`
  flex-shrink: 0;
  width: 44px;
  height: 44px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: ${radius.md};
  background: ${colors.primary}1a;
`;

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
`;

export const DragHandle = styled.button`
  flex-shrink: 0;
  align-self: center;

  width: 24px;
  height: 44px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: transparent;
  border: none;
  cursor: grab;
  touch-action: none;

  color: ${colors.onSurfaceVariant}80;
  transition: color 0.15s;

  &:hover {
    color: ${colors.onSurfaceVariant};
  }

  &:active {
    cursor: grabbing;
  }
`;

export const Title = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${colors.onSurface};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Subtitle = styled.span`
  font-size: 13px;
  color: ${colors.onSurfaceVariant};
  line-height: 1.5;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const DateLabel = styled.span`
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${colors.onSurfaceVariant}b3;
  margin-top: 6px;
`;

export const ActionsRow = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ActionButton = styled.button<{ danger?: boolean }>`
  width: 38px;
  height: 38px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: transparent;
  border: none;
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  color: ${colors.onSurfaceVariant};
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    background-color: ${colors.surfaceContainer};
    color: ${props => (props.danger ? colors.error : colors.primary)};
  }
`;
